// extracted by mini-css-extract-plugin
export default {"container":"chat-container_container__d6OGe"};